export default "__VITE_ASSET__CuHR$SCD__"